<template>
  <div class="playersInforRadar" ref="playersInforRadar">
    <div class="playerItem home">
      <AbPlayerImg
        :playerImg="homePlayer.profilePicture"
        :playerNum="homePlayer.shirtNumber * 1"
        :playerName="homePlayer.playerName"
        :countryImg="homeInfo.teamLogo || homePlayer.countryLogo"
        :countryName="homeInfo.teamName || homePlayer.countryName"
        :width="'100%'"
      />
    </div>
    <div class="themeData">
      <div
        class="radar"
        ref="radarDom"
        :style="{ height: Math.floor((radarWidth / 4) * 3) + 'px' }"
      ></div>
    </div>
    <div class="playerItem away">
      <AbPlayerImg
        :playerImg="awayPlayer.profilePicture"
        :playerNum="awayPlayer.shirtNumber * 1"
        :playerName="awayPlayer.playerName"
        :countryImg="awayInfo.teamLogo || awayPlayer.countryLogo"
        :countryName="awayInfo.teamName || awayPlayer.countryName"
        :width="'100%'"
      />
    </div>
  </div>
</template>

<script>
// 球员数据对比 主题
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'playersInforRadar',
  mixins: [canvasToImage_base64_data_mixin],
  components: { AbPlayerImg },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      radarWidth: 0,
      echartInstance: null,
    }
  },
  computed: {
    objectInfo() {
      return this.datas?.objectInfo || []
    },
    homeInfo() {
      return this.objectInfo[0] || {}
    },
    awayInfo() {
      return this.objectInfo[1] || {}
    },
    homePlayer() {
      return this.homeInfo?.playerInfos?.[0] || {}
    },
    awayPlayer() {
      return this.awayInfo?.playerInfos?.[0] || {}
    },
  },
  watch: {
    datas(val) {
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.radarWidth = this.$refs.radarDom.clientWidth
      setTimeout(() => {
        this.initChart(this.$refs.radarDom)
      }, 10)
    })
  },
  beforeDestroy() {
    this.echartInstance?.dispose()
  },
  methods: {
    initChart(echartRef) {
      this.echartInstance = this.$echarts.init(echartRef, null, {
        renderer: 'canvas',
      })
      setTimeout(() => {
        this.echartInstance.resize()
      }, 0)
      const keyArr = this.datas.statisticsModels || []
      const dataList = this.datas.data.dataList
      const maxList = this.datas.data.maxList

      const radarNameArr = [
        this.homePlayer?.playerName || '',
        this.awayPlayer?.playerName || '',
      ]
      const indicator = keyArr.map((model) => ({
        name: model.name,
        max: maxList[model.statisticalEn],
      }))
      const seriesData = dataList.map((item, index) => {
        const value = keyArr.map((key) => {
          return item[key['statisticalEn']] ? item[key['statisticalEn']] : 0
        })
        const color = index === 0 ? '#04FE02' : '#FDFC01'
        return {
          value,
          lineStyle: { width: 2, color },
          name: radarNameArr[index],
        }
      })
      const fontSize = 15 * document.body.clientWidth / 1920

      let options = {
        title: {
          show: false,
          text: 'Basic Radar Chart',
        },
        color: ['#04FE02', '#FDFC01'],
        tooltip: {
          show: true,
        },
        radar: {
          shape: 'polygon',
          center: ['50%', '50%'],
          radius: '60%',
          indicator,
          axisName: { color: '#fff', fontSize: fontSize, fontWeight: 'bold' },
          axisLine: { lineStyle: { color: '#fff', width: 1, opacity: 0.5 } },
          splitLine: { lineStyle: { color: '#fff', width: 1, opacity: 0.5 } },
          splitArea: { show: false },
          areaStyle: { opacity: 0 },
        },
        series: [
          {
            type: 'radar',
            shadowBlur: 0,
            shadowColor: 'transparent',
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: 'transparent', // 填充透明 → 空心
              borderColor: '#fff', // 边框颜色
              borderWidth: 2, // 边框粗细
            },
            data: seriesData,
          },
        ],
      }
      if (this.isAutoExportPng) {
        this.echartInstance.on('finished', () => {
          this.downLoad()
        })
      }
      this.echartInstance.setOption(options)
    },

    downLoad() {
      const imgdata = this.echartInstance.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: 'transparent',
      })
      this.$emit('uploadData', { imgdata })
    },
  },
}
</script>

<style lang="scss" scoped>
.playersInforRadar {
  position: relative;
  width: 100%;
  height: 22vw;
  padding: 0 3%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  .playerItem {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 6.94vw;
  }
  .themeData {
    width: calc(100% - 13.88vw);
    height: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    padding: 0 2%;
    .radar {
      width: 100%;
      height: 100%;
      transform: rotateX(0deg);
      background: #27568e;
    }
  }
}
.mixtmt_ipad .playersInforRadar {
  padding: 0 2%;
  .themeData {
    .echart_dom {
      width: 85%;
    }
  }
}
</style>
